/* Remodius V29 — snel toevoegen voor remodius-product-card buiten de collectie-tabs (gedelegeerd, één keer per pagina).
   Formulieren die remodius-collection-tabs.js al afhandelt (preventDefault) worden overgeslagen. */
(function(){
  if (window.__rmdQuickAdd) return; window.__rmdQuickAdd = true;
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (e.defaultPrevented || !form.matches || !form.matches('form[data-rem-coll-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button'); if (btn) btn.disabled = true;
    fetch(form.action, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function(r){ if (!r.ok) throw new Error('add'); return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { cart: cart } }));
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function(){ form.submit(); })
      .finally(function(){ if (btn) btn.disabled = false; });
  });
})();
